import { useEffect, useRef } from "react";

interface ScrollToTopOptions {
  offset?: number;
  behavior?: ScrollBehavior;
  targetRef?: React.RefObject<HTMLElement | null>;
  skipFirstRender?: boolean;
}

const useScrollToTop = (
  page: number | string,
  {
    offset = 0,
    behavior = "smooth",
    targetRef,
    skipFirstRender = true,
  }: ScrollToTopOptions = {},
): void => {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (skipFirstRender && isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (targetRef?.current) {
      targetRef.current.scrollTo({ top: offset, behavior });
    } else {
      window.scrollTo({ top: offset, behavior });
    }
  }, [page]); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useScrollToTop;
